import React from 'react';
import PropTypes from 'prop-types';
import {Tag, Typography} from 'antd';
import _ from 'lodash';

import {DepartTag, AppTagTag, TagTag, UserTag} from '@/component';

import {formatLong} from '@/util/dateUtils';

import styles from './MsgMeta.module.less';

export default function MsgMeta({message}) {
    // console.log('message', message);
    const {toAll, tos, safe, createTime, userName, msgDirection, fixedTimeMsg, fixedTime} = message;

    function renderTos() {
        const toUsers = tos
            .filter(to => to.msgToType === 'touser')
            .map(({id, msgToName}) => <UserTag key={id}>{msgToName}</UserTag>);

        const toDeparts = tos
            .filter(to => to.msgToType === 'toparty')
            .map(({id, msgToName}) => <DepartTag key={id}>{msgToName}</DepartTag>);

        const toTags = tos
            .filter(to => to.msgToType === 'totag')
            .map(({id, msgToName}) => <TagTag key={id}>{msgToName}</TagTag>);

        const toAppTags = tos
            .filter(to => to.msgToType === 'toapptag')
            .map(({id, msgToName}) => <AppTagTag key={id}>{msgToName}</AppTagTag>);

        return (
            <div className={styles.tos}>
                {!_.isEmpty(toDeparts) && <div>{toDeparts}</div>}
                {!_.isEmpty(toUsers) && <div>{toUsers}</div>}
                {!_.isEmpty(toTags) && <div>{toTags}</div>}
                {!_.isEmpty(toAppTags) && <div>{toAppTags}</div>}
            </div>
        );
    }

    return (
        <div className={styles.container}>
            <div className={styles.item}>
                <div className={styles.title}>发送人：</div>
                <Tag>{userName}</Tag>
            </div>

            <div className={styles.item}>
                <div className={styles.title}>创建时间：</div>
                <Typography.Text type="secondary">{formatLong(createTime)}</Typography.Text>
            </div>

            {fixedTimeMsg && (
                <>
                    <div className={styles.item}>
                        <div className={styles.title}>发送时间：</div>
                        <Typography.Text type="secondary">{formatLong(fixedTime)}</Typography.Text>
                    </div>
                </>
            )}

            {msgDirection === 'send' && (
                <>
                    <div className={styles.item}>
                        <div className={styles.title}>分享配置：</div>
                        {safe === 0 ? (
                            <Tag color="#2db7f5">可分享</Tag>
                        ) : (
                            <Tag color="#f50">不可分享</Tag>
                        )}
                    </div>
                    <div className={styles.item}>
                        <div className={styles.title}>发送范围：</div>
                        {toAll ? '所有人' : renderTos()}
                    </div>
                </>
            )}
        </div>
    );
}

MsgMeta.propTypes = {
    message: PropTypes.object,
};
